import React from 'react';

const LabelUI = (props) => {
    return (
        <div className={`input-field no-padding ${props.class ? props.class : 'col s12'}`}>
            <span id={props.id} style={{ display: 'block' }} className={`field ${props.field ? props.field : 'f-1r'}`}>{props.value}</span>
            <label className="active" htmlFor={props.id}>{props.label}</label>
        </div>
    );
};

export default LabelUI;
